module.exports = {"340871001":"菱北街道","340871100":"老峰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340871.json
// module id = 1100
// module chunks = 0